import { html } from 'lit';
const Summarize =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.5 5c.064 0 .117.048.124.11.046.405.169.7.368.902s.486.327.894.363a.125.125 0 0 1 0 .25c-.401.034-.696.16-.899.362-.203.203-.328.498-.363.899a.125.125 0 0 1-.248 0c-.037-.408-.162-.696-.364-.894-.203-.2-.497-.322-.901-.368a.125.125 0 0 1 0-.248c.41-.048.699-.17.897-.368s.32-.487.368-.897A.125.125 0 0 1 11.5 5M8.073 6.244a.275.275 0 0 0-.546 0c-.104.903-.374 1.538-.81 1.973-.435.436-1.07.706-1.974.81a.275.275 0 0 0 .001.546c.888.1 1.537.37 1.983.809.444.436.72 1.07.8 1.967a.275.275 0 0 0 .547 0c.076-.882.352-1.53.798-1.977.447-.446 1.095-.722 1.977-.798a.275.275 0 0 0 0-.548c-.896-.08-1.531-.355-1.967-.8-.438-.445-.708-1.094-.809-1.982m6.427.506a.75.75 0 0 0 0 1.5H19a.75.75 0 0 0 0-1.5zm-1.5 3.5a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM4.25 14.5a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 17.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
export default Summarize;
